export enum FormMode {
    View,
    Edit,
    Add
}
